import { TrendingUp, Package } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";

const DemandChart = ({ demandAnalysis }) => {
  return (
    <div className="bg-white border border-slate-200 rounded-sm">
      <div className="p-6 border-b border-slate-200">
        <h2 className="text-lg font-bold text-slate-900 uppercase tracking-wider" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Demand Analysis
        </h2>
        <p className="text-xs text-slate-500 mt-1">Top selling items by revenue</p>
      </div>
      <div className="p-6">
        {demandAnalysis.length === 0 ? (
          <div className="py-8 text-center">
            <TrendingUp className="mx-auto text-slate-300 mb-3" size={48} />
            <p className="text-slate-500">No sales data available</p>
            <p className="text-xs text-slate-400 mt-1">Start recording transactions to see demand analysis</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={demandAnalysis}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="item_part_number" tick={{ fontSize: 12 }} stroke="#64748b" />
              <YAxis tick={{ fontSize: 12 }} stroke="#64748b" />
              <Tooltip 
                contentStyle={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '2px' }}
                formatter={(value) => `${value} units`}
                labelFormatter={(label) => `Part: ${label}`}
              />
              <Bar dataKey="total_sales" radius={[4, 4, 0, 0]}>
                {demandAnalysis.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill="#f97316" />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

const SalesSummary = ({ demandAnalysis }) => {
  return (
    <div className="bg-white border border-slate-200 rounded-sm">
      <div className="p-6 border-b border-slate-200">
        <h2 className="text-lg font-bold text-slate-900 uppercase tracking-wider" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Sales Summary
        </h2>
        <p className="text-xs text-slate-500 mt-1">Transaction volume by item</p>
      </div>
      <div className="p-6">
        {demandAnalysis.length === 0 ? (
          <div className="py-8 text-center">
            <Package className="mx-auto text-slate-300 mb-3" size={48} />
            <p className="text-slate-500">No transaction data</p>
          </div>
        ) : (
          <div className="space-y-4 max-h-[300px] overflow-y-auto">
            {demandAnalysis.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-slate-50 border border-slate-200 rounded-sm hover:bg-orange-50/50 transition-colors">
                <div>
                  <p className="text-sm font-bold text-slate-900">{item.item_name}</p>
                  <p className="text-xs text-slate-500">Part#: {item.item_part_number}</p>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-orange-600">{item.total_sales}</p>
                  <p className="text-xs text-slate-500">units sold</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export { DemandChart, SalesSummary };
